<script>
  import { onMount } from "svelte";
  import { _ } from "svelte-i18n";
  import Button from "lib/components/Button.svelte";
  import Header from "lib/components/Header.svelte";
  import Card from "lib/components/Card.svelte";
  import Container from "lib/components/Container.svelte";
  import Grid from "lib/components/Grid.svelte";
  import Footer from "lib/components/Footer.svelte";
  import Hero from "lib/components/Hero.svelte";

  // Who section data
  const whoCards = [
    {
      icon: "🌏",
      titleKey: "home.who.card1.title",
      descriptionKey: "home.who.card1.description",
    },
    {
      icon: "🏛️",
      titleKey: "home.who.card2.title",
      descriptionKey: "home.who.card2.description",
    },
    {
      icon: "🎁",
      titleKey: "home.who.card3.title",
      descriptionKey: "home.who.card3.description",
    },
    {
      icon: "🤲",
      titleKey: "home.who.card4.title",
      descriptionKey: "home.who.card4.description",
    },
    {
      icon: "✈️",
      titleKey: "home.who.card5.title",
      descriptionKey: "home.who.card5.description",
    },
  ];
</script>

<Header />

<!-- Hero Section with Info Cards -->
<Hero />

<Container variant="light" class="who-section">
  <div class="who-header">
    <h2 class="section-title">{$_("home.who.title")}</h2>
    <p class="section-subtitle">
      {$_("home.who.subtitle")}
    </p>
  </div>

  <Grid columns="5" gap="1.5rem" class="who-cards">
    {#each whoCards as card}
      <Card variant="light" size="compact" alignment="center">
        <div class="card-icon" slot="icon">{card.icon}</div>
        <h3 slot="title">{$_(card.titleKey)}</h3>
        <p slot="description">{$_(card.descriptionKey)}</p>
      </Card>
    {/each}
  </Grid>

  <div class="section-cta">
    <p class="cta-text">{$_("home.cta.text")}</p>
    <Button href="/register" variant="primary" size="large"
      >{$_("home.cta.button")}</Button
    >
  </div>
</Container>

<Footer />

<style lang="scss">
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap");

  :root {
    --card-bg: #230822;
    --max-width: 1400px;
  }

  :global(body) {
    background-color: #1a091c;
    margin: 0;
    padding: 0;
    font-family: "Inter", sans-serif;
    min-height: 100vh;
  }

  /* Who Section */
  .who-header {
    text-align: center;
    max-width: 800px;
    margin: 0 auto 3rem;
  }

  .section-title {
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    color: #2c1810;
    line-height: 1.2;
  }

  .section-subtitle {
    font-size: 1.2rem;
    line-height: 1.6;
    color: #5d4a3a;
    margin: 0;
    font-weight: 400;
  }

  /* Card Icons */
  :global(.card-icon) {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    transition: all 0.3s ease;
    filter: hue-rotate(0deg) saturate(0.7) brightness(1.1);
  }

  :global(.card:hover .card-icon) {
    filter: none;
    transform: scale(1.1);
  }
  .section-cta {
    text-align: center;
    margin-top: 3rem;
    padding-top: 2rem;
    border-top: 1px solid rgba(93, 74, 58, 0.2);
  }

  .cta-text {
    font-size: 1.1rem;
    color: #5d4a3a;
    margin-bottom: 1.5rem;
    font-weight: 500;
  }

  /* Responsive Design */
  @media (max-width: 1200px) {
    :global(.who-cards) {
      grid-template-columns: repeat(3, 1fr) !important;
    }
  }

  @media (max-width: 1024px) {
    :global(.who-cards) {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }

  @media (max-width: 768px) {
    :global(.who-cards) {
      grid-template-columns: 1fr !important;
    }

    .section-title {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 480px) {
    .section-title {
      font-size: 2rem;
    }

    .section-subtitle {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 320px) {
    .section-title {
      font-size: 1.75rem;
    }
  }
</style>
